import { ESubscriptionType } from '@mopla/data-models';

export const getDTicketPageTitleKey = (
	type = ESubscriptionType.GERMANYTICKET
): string => {
	switch (type) {
		case ESubscriptionType.MOPLA:
		case ESubscriptionType.SPENDIT:
			return 'page_title_section.dticket_page_title_jobticket';
		case ESubscriptionType.SCHOOL:
		case ESubscriptionType.UNIVERSITY:
			return 'page_title_section.dticket_page_title_school';
		default:
			return 'page_title_section.dticket_page_title';
	}
};

export const getIsJobticket = (
	type = ESubscriptionType.GERMANYTICKET
): boolean => {
	return type === ESubscriptionType.MOPLA || type === ESubscriptionType.SPENDIT;
};
